/**
 * Labstep
 */

import { getMetadataColDefs } from 'labstep-web/grid/Index/coldefs/Resource/metadatas';
import type { Resource } from 'labstep-web/models/resource.model';
import { ResourceItem } from 'labstep-web/models/resource-item.model';

/**
 * For all metadatas on resource item template, return a column
 * @param resourceTemplate Resource template
 * @returns Column definitions
 */
export const getResourceItemMetadataColDefs = (
  resourceTemplate?: Resource | null,
) =>
  resourceTemplate?.resource_item_template
    ? getMetadataColDefs(
        ResourceItem.entityName,
        resourceTemplate.resource_item_template,
        undefined,
        {
          entityName: ResourceItem.entityName,
        },
      )
    : [];
